export const PERIOD_OPTIONS = [
  { key: 'thisWeek', label: 'This week' },
  { key: 'lastWeek', label: 'Last week' },
  { key: 'thisMonth', label: 'This month' },
  { key: 'custom', label: 'Custom' },
];

export const MOCK_PROJECTS = [
  { id: 101, name: 'Aurora Redesign' },
  { id: 102, name: 'Orchid Mobile' },
  { id: 103, name: 'Nimbus Migration' },
  { id: 104, name: 'Atlas Retainer' },
];

// Deliverable: 10–15 people with required fields.
export const MOCK_PEOPLE = [
  {
    id: 'u1',
    name: 'Ivana Kovač',
    role: 'Designer',
    avatarUrl: '',
    plannedHours: 44,
    loggedHours: 38,
    overdueCount: 3,
    noLogDays: 0,
    vacationDays: 0,
    projectsCount: 2,
    projectIds: [101, 104],
  },
  {
    id: 'u2',
    name: 'Petar Horvat',
    role: 'Engineer',
    avatarUrl: '',
    plannedHours: 50,
    loggedHours: 30,
    overdueCount: 7,
    noLogDays: 0,
    vacationDays: 0,
    projectsCount: 1,
    projectIds: [103],
  },
  {
    id: 'u3',
    name: 'Jana Marić',
    role: 'PM',
    avatarUrl: '',
    plannedHours: 36,
    loggedHours: 10,
    overdueCount: 0,
    noLogDays: 2,
    vacationDays: 0,
    projectsCount: 3,
    projectIds: [101, 102, 103],
  },
  {
    id: 'u4',
    name: 'Mirna Babić',
    role: 'Engineer',
    avatarUrl: '',
    plannedHours: 40,
    loggedHours: 28,
    overdueCount: 0,
    noLogDays: 0,
    vacationDays: 1,
    projectsCount: 2,
    projectIds: [102, 104],
  },
  {
    id: 'u5',
    name: 'Josipa Novak',
    role: 'QA',
    avatarUrl: '',
    plannedHours: 32,
    loggedHours: 0,
    overdueCount: 2,
    noLogDays: 3,
    vacationDays: 0,
    projectsCount: 1,
    projectIds: [104],
  },
  {
    id: 'u6',
    name: 'Lea Perić',
    role: 'Designer',
    avatarUrl: '',
    plannedHours: 20,
    loggedHours: 18,
    overdueCount: 0,
    noLogDays: 0,
    vacationDays: 2,
    projectsCount: 1,
    projectIds: [102],
  },
  {
    id: 'u7',
    name: 'Elena Jurić',
    role: 'Engineer',
    avatarUrl: '',
    plannedHours: 42,
    loggedHours: 41,
    overdueCount: 0,
    noLogDays: 0,
    vacationDays: 0,
    projectsCount: 2,
    projectIds: [101, 103],
  },
  {
    id: 'u8',
    name: 'Marko Radić',
    role: 'Engineer',
    avatarUrl: '',
    plannedHours: 10,
    loggedHours: 4,
    overdueCount: 0,
    noLogDays: 0,
    vacationDays: 0,
    projectsCount: 1,
    projectIds: [103],
  },
  {
    id: 'u9',
    name: 'Ana Šimić',
    role: 'Ops',
    avatarUrl: '',
    plannedHours: 28,
    loggedHours: 26,
    overdueCount: 5,
    noLogDays: 1,
    vacationDays: 0,
    projectsCount: 2,
    projectIds: [104, 102],
  },
  {
    id: 'u10',
    name: 'Luka Krpan',
    role: 'Engineer',
    avatarUrl: '',
    plannedHours: 40,
    loggedHours: 12,
    overdueCount: 0,
    noLogDays: 0,
    vacationDays: 0,
    projectsCount: 1,
    projectIds: [101],
  },
  {
    id: 'u11',
    name: 'Nika Vidović',
    role: 'Content',
    avatarUrl: '',
    plannedHours: 16,
    loggedHours: 14,
    overdueCount: 0,
    noLogDays: 0,
    vacationDays: 0,
    projectsCount: 1,
    projectIds: [102],
  },
  {
    id: 'u12',
    name: 'Toni Blažević',
    role: 'Engineer',
    avatarUrl: '',
    plannedHours: 48,
    loggedHours: 48,
    overdueCount: 1,
    noLogDays: 0,
    vacationDays: 0,
    projectsCount: 2,
    projectIds: [103, 104],
  },
];

export function startOfWeekMonday(date) {
  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const dow = d.getDay(); // 0=Sun..6=Sat
  const offset = dow === 0 ? -6 : 1 - dow; // Monday start
  d.setDate(d.getDate() + offset);
  return d;
}

export function endOfWeekMonday(date) {
  const start = startOfWeekMonday(date);
  const d = new Date(start);
  d.setDate(d.getDate() + 6);
  return d;
}

export function startOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function endOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

export function getPeriodRange(periodKey, today = new Date()) {
  const base = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  if (periodKey === 'lastWeek') {
    const prev = new Date(base);
    prev.setDate(prev.getDate() - 7);
    return { start: startOfWeekMonday(prev), end: endOfWeekMonday(prev) };
  }
  if (periodKey === 'thisMonth') {
    return { start: startOfMonth(base), end: endOfMonth(base) };
  }
  // 'custom' is a placeholder until we wire an actual range picker.
  return { start: startOfWeekMonday(base), end: endOfWeekMonday(base) };
}

export function countWorkdaysInclusive(start, end) {
  const s = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  const e = new Date(end.getFullYear(), end.getMonth(), end.getDate());
  if (e < s) return 0;
  let days = 0;
  for (let d = new Date(s); d <= e; d.setDate(d.getDate() + 1)) {
    const dow = d.getDay();
    if (dow !== 0 && dow !== 6) days += 1;
  }
  return days;
}

export function clamp01(n) {
  return Math.max(0, Math.min(1, Number(n || 0)));
}

export function formatHours(h) {
  const n = Number(h || 0);
  if (Number.isNaN(n)) return '0h';
  const rounded = Math.round(n * 10) / 10;
  const asInt = Math.round(rounded);
  const display = Math.abs(rounded - asInt) < 0.0001 ? String(asInt) : String(rounded);
  return `${display}h`;
}

export function formatPct(ratio) {
  const n = Number(ratio);
  if (!Number.isFinite(n) || n <= 0) return '0%';
  return `${Math.round(n * 100)}%`;
}

export function initials(name) {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] || '';
  const last = parts.length > 1 ? parts[parts.length - 1]?.[0] : (parts[0]?.[1] || '');
  return (first + last).toUpperCase();
}
